export const fmtPrice = (v) =>
  `${Number(v || 0).toFixed(2).replace(".", ",")} lei`;

export const FREE_SHIPPING = 300;
export const SHIPPING_COST = 19.99;

export const STATUS_LABELS = {
  noua: "Nouă",
  in_procesare: "În procesare",
  expediata: "Expediată",
  livrata: "Livrată",
  anulata: "Anulată",
};

export const STATUS_STYLES = {
  noua: "bg-sky-100 text-sky-700",
  in_procesare: "bg-amber-100 text-amber-700",
  expediata: "bg-violet-100 text-violet-700",
  livrata: "bg-emerald-100 text-emerald-700",
  anulata: "bg-rose-100 text-rose-700",
};

export const ORDER_STATUSES = Object.keys(STATUS_LABELS);
